<script setup lang="ts">
const { $ads } = useNuxtApp()
const route = useRoute()
</script>

<template>
  <div class="space-y-3">
    <div class="wwads-cn wwads-vertical w-full my-4" data-id="354" />
    <!-- <AdsMN v-if="route.path.length % 2 === 0" /> -->
    <!-- <AdsNuxtCertificate v-else /> -->
    <!-- <AdsFreeWeekend /> -->
    <!-- <AdsFallback v-if="$ads.adBlocked.value" /> -->
    <!-- <LazyAdsCarbon v-else :key="route.path" /> -->
  </div>
</template>
